module.exports = __webpack_public_path__ + "static/media/text-align.cf7bf726.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cart/text-align.svg
// module id = 1940
// module chunks = 1